import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,
  Label,
  Radio,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { termActions } from '../../actions/term.actions';
import { userConstants } from '../../constants/user.constants';

class TermsFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      term: {
        version: '',
        title: '',
        body: '',
        active: true,
      },
      errors: {},
    };
  }

  componentDidMount() {
    const { match, dispatch, me } = this.props;

    // Check Permission
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    if (match.params.id) {
      dispatch(termActions.get(match.params.id))
        .then(() => {
          if (!this.props.term) {
            return;
          }
          const term = _.mapKeys(this.props.term, function (v, k) { return k[0].toLowerCase() + k.substr(1); });
          this.setState({ term });
        });
    }
  }

  static get propTypes() {
    return {
      me: PropTypes.any,
      term: PropTypes.any,
      loading: PropTypes.bool,
      match: PropTypes.any,
    };
  }

  handleChange(field, data) {
    const { term } = this.state;
    term[field] = data;
    this.setState({ term });
  }

  validate() {
    const { term } = this.state;

    let errors = {};
    let valid = true;

    if (!term.version || term.version.trim().length == 0) {
      errors.version = "Preencha a versão";
      valid = false;
    }

    if (!term.title || term.title.trim().length == 0) {
      errors.title = "Preencha o título";
      valid = false;
    }

    if (!term.body || term.body.replace(/<[^>]*>/g, '').trim().length == 0) {
      errors.body = "Preencha o conteúdo do termo";
      valid = false;
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { term } = this.state;

    dispatch(termActions.save(term));
  }

  render() {
    const { term, errors } = this.state;

    return (
      <Fragment>
        <h1>Termo de Uso</h1>
        <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
          <Form.Input required error={!!errors.version} label='Versão' value={term.version} name='version' type='text' placeholder='Ex.: 1.0' onChange={(e, data) => this.handleChange("version", data.value)} />
          { errors.version && <Label color='red'>{errors.version}</Label>}

          <Form.Input required error={!!errors.title} label='Título' value={term.title} name='title' type='text' onChange={(e, data) => this.handleChange("title", data.value)} />
          { errors.title && <Label color='red'>{errors.title}</Label>}

          <Form.Field required error={!!errors.body}>
            <label>Conteúdo</label>
            <ReactQuill
              theme="snow"
              value={term.body || ''}
              style={{ width: '100%', minHeight: '200px' }}
              onChange={(value) => this.handleChange('body', value)} />
          </Form.Field>
          { errors.body && <Label color='red'>{errors.body}</Label>}

          <Form.Input style={{ marginTop: '8px' }}>
            <Radio toggle checked={!!term.active} label='Ativo (versão exigida dos usuários)' onChange={(e, data) => this.handleChange("active", data.checked)} />
          </Form.Input>

          <Message info size='small'>
            Ao ativar este termo, qualquer outra versão ativa é desativada automaticamente. Apenas uma versão fica vigente por vez.
          </Message>

          <Button primary type='submit'>{term.id ? 'Alterar' : 'Criar'} Termo</Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { term, users } = state;

  return {
    me: users.me || null,
    loading: term.loading,
    term: term.item || null,
  };
}

const connectedTermsFormScreen = connect(mapStateToProps)(TermsFormScreen);
export { connectedTermsFormScreen as TermsFormScreen };
